import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import BackdropModal from 'components/portal/backdrop-modal'
import styles from './virtual-plan-outfit-modal.scss'

const VirtualPlanOutfitModal = ({ triggerButton, children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false)

  const handleClickTrigger = () => {
    setIsOpenModal(true)
  }

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      {triggerButton &&
        React.cloneElement(triggerButton, {
          onClick: (e) => {
            e.stopPropagation()
            handleClickTrigger()
            triggerButton.props.onClick?.(e)
          },
          onKeyDown: (e) => {
            e.stopPropagation()
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleClickTrigger()
            }
          },
        })}
      <BackdropModal
        freezeBody
        zIndex={2000}
        isOpen={isOpenModal}
        onBackdropClick={() => {
          setIsOpenModal(false)
        }}
        onRouteChange={() => {
          setIsOpenModal(false)
        }}
      >
        <div className="virtual-plan-outfit-modal">{children}</div>
      </BackdropModal>
    </React.Fragment>
  )
}

// VirtualPlanOutfitModal.defaultProps = {
//   isPhone: false,
// }

VirtualPlanOutfitModal.propTypes = {
  // t: PropTypes.func.isRequired,
  triggerButton: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
}

export default withI18next()(VirtualPlanOutfitModal)
